import React, { useEffect } from 'react';
import Sentry from 'src/services/sentry';

import {
  Modal,
  ModalTitle,
  ModalContent,
} from 'src/components/Modal';
import { Icon } from 'src/components/Icon';
import { Button } from 'src/components/Button';
import styles from './SystemError.module.scss';

interface SystemErrorProps {
  error?: unknown;
  componentName?: string;
  componentStack?: string | null;
}

export function SystemError({ error, componentName, componentStack }: SystemErrorProps) {

  useEffect(() => {
    Sentry.withScope((scope) => {
      scope.setTag('error_modal', 'system');
      if (componentName) {
        scope.setTag('error_component', componentName);
      }
      if (componentStack) {
        scope.setExtra('componentStack', componentStack);
      }
      if (error instanceof Error) {
        Sentry.captureException(error);
      } else {
        Sentry.captureMessage('Error modal shown: system', 'error');
      }
    });
    if (typeof window !== 'undefined' && typeof (window as any).ym === 'function') {
      (window as any).ym(106854947, 'reachGoal', 'error_modal_system');
    }
  }, []);

  const handleClose = () => {
    window.location.href = '/'
  };

  const hanldeTryAgain = () => {
    window.location.href = '/'
  };

  return (
    <Modal onClose={handleClose}>
      <ModalContent
        onClose={handleClose}
        className={styles.errorContainer}
        closeButtonClassName={styles.closeButton}
      >
        <Icon className={styles.errorIcon} name="Report" />
        <ModalTitle className={styles.errorTitle}>
          Something went wrong...
        </ModalTitle>
        <div className={styles.errorDescription}>
          We understand the problem and are already fixing it.
        </div>
        <Button className={styles.errorButton} onClick={hanldeTryAgain}>
          Try again
        </Button>
      </ModalContent>
    </Modal>
  );
}
